import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import "../style.css";
import Footer from "./footer";
import DashboardNavbar from "./DashboardNavbar";
import {
  FaLifeRing,
  FaSitemap,
  FaHandHoldingUsd,
  FaCoins,
  FaSpinner,
  FaUserPlus,
  FaMoneyBillWave,
  FaChartBar,
} from "react-icons/fa";
import { getData } from "../api/protectedApi";
import { toast } from "react-toastify";

const Poolinfo = () => {
  const [userName, setUserName] = useState("");
  const [dashboard, setDashboard] = useState({});
  const [poolInfo, setPoolInfo] = useState(null);

  /* ================= USER PROFILE ================= */
  const getUserProfile = async () => {
    try {
      const res = await getData("/profile");
      if (res?.data?.user_data?.name) {
        setUserName(res.data.user_data.name);
      }
    } catch (error) {
      console.error("Failed to fetch user data", error);
    }
  };

  /* ================= DASHBOARD DATA ================= */
  const loadDashboard = async () => {
    try {
      const res = await getData("/dashboard");
      if (res?.data?.data) {
        setDashboard(res.data.data);
      }
    } catch (error) {
      toast.error("Failed to load dashboard");
    }
  };

  /* ================= POOL INFO ================= */
  const loadPoolInfo = async () => {
    try {
      const res = await getData("/user_pools");
      if (res?.data?.status && res.data.data.length > 0) {
        setPoolInfo(res.data.data[0]); // first pool object
      }
    } catch (error) {
      toast.error("Failed to load pool info");
      console.error(error);
    }
  };

  useEffect(() => {
    getUserProfile();
    loadDashboard();
    loadPoolInfo();
  }, []);

  return (
    <div
      style={{
        backgroundColor: "#0d0e13",
        minHeight: "100vh",
        color: "#fff",
        padding: "12px 0",
        fontFamily: "Inter, sans-serif",
      }}
    >
      {/* NAVBAR */}
      <DashboardNavbar />

      {/* HEADER */}
      <section>
        <div className="container pt-5">
          <div className="mb-4">
            <div className="welcome">Welcome to Hifi Internationals</div>
            <div className="hello">Hello, {userName || "User"}</div>
          </div>
        </div>
      </section>

      {/* POOL INFO */}
      <section>
        <div
          className="container-fluid py-3"
          style={{ backgroundColor: "#141245" }}
        >
          <div className="container">
            <div className="mb-4">
              <div className="hifi1-race-label">Active : $30</div>
              <div className="hifi1-race-title">Activation Pool</div>
            </div>

            <div className="row g-4">
              {/* Pool Status */}
              <div className="col-lg-3 col-md-6 col-12">
                <div className="hifi1-pool-card">
                  <div className="hifi1-icon blue">
                    <FaSpinner size={40} />
                  </div>
                  <div className="hifi1-card-label">Pool Status</div>
                  <div className="hifi1-card-value">
                    {poolInfo ? "Active" : "Inactive"}
                  </div>
                </div>
              </div>

              {/* Total Referrals */}
              <div className="col-lg-3 col-md-6 col-12">
                <div className="hifi1-pool-card">
                  <div className="hifi1-icon blue">
                    <FaUserPlus size={40} />
                  </div>
                  <div className="hifi1-card-label">Total Referrals</div>
                  <div className="hifi1-card-value">
                    {dashboard?.directs || 0}
                  </div>
                </div>
              </div>

              {/* Referral Bonus */}
              <div className="col-lg-3 col-md-6 col-12">
                <div className="hifi1-pool-card">
                  <div className="hifi1-icon orange">
                    <FaMoneyBillWave size={40} />
                  </div>
                  <div className="hifi1-card-label">Referral Bonus</div>
                  <div className="hifi1-card-value">
                    {dashboard?.directIncome || 0}
                  </div>
                </div>
              </div>

              {/* Pool Bonus */}
              <div className="col-lg-3 col-md-6 col-12">
                <div className="hifi1-pool-card">
                  <div className="hifi1-icon darkblue">
                    <FaChartBar size={40} />
                  </div>
                  <div className="hifi1-card-label">Pool Bonus</div>
                  <div className="hifi1-card-value">
                    {dashboard?.poolIncome || 0}
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </section>

      {/* QUICK LINKS */}
      <section className="hifi1section py-5">
        <div className="container">
          <div className="row g-4 justify-content-center hifi1section-2">
            <div className="col-xl-3 col-lg-4 col-md-6">
              <Link to="/poolinfo" className="text-decoration-none">
                <div className="hifi-card hifi1-icon blue">
                  <FaLifeRing size={40} />
                  <span>POOL INFO</span>
                </div>
              </Link>
            </div>

            <div className="col-xl-3 col-lg-4 col-md-6">
              <Link to="/levelincome" className="text-decoration-none">
                <div className="hifi-card hifi1-icon blue">
                  <FaSitemap size={40} />
                  <span>LEVEL INCOME</span>
                </div>
              </Link>
            </div>

            <div className="col-xl-3 col-lg-4 col-md-6">
              <Link to="/directincome" className="text-decoration-none">
                <div className="hifi-card hifi1-icon blue">
                  <FaHandHoldingUsd size={32} />
                  <span>REFERRAL INCOME</span>
                </div>
              </Link>
            </div>

            <div className="col-xl-3 col-lg-4 col-md-6">
              <Link to="/poolincome" className="text-decoration-none">
                <div className="hifi-card hifi1-icon blue">
                  <FaCoins size={40} />
                  <span>POOL INCOME</span>
                </div>
              </Link>
            </div>
          </div>
        </div>
      </section>
      {/* POOL DETAILS TABLE */}
      <div className="container">
        <div className="directs-wrapper">
          <div className="table-responsive mt-4">
            <table className="table directs-table align-middle">
              <thead>
                <tr>
                  <th>Pool ID</th>
                  <th>User ID</th>
                  <th>Upline ID</th>
                  <th>Down Node</th>
                  <th>Total Downline</th>
                  <th>Created At</th>
                </tr>
              </thead>

              <tbody>
                {!poolInfo ? (
                  <tr>
                    <td colSpan="6" className="text-center text-white">
                      No records found
                    </td>
                  </tr>
                ) : (
                  <tr>
                    <td>{poolInfo.pool_id}</td>
                    <td>{poolInfo.user_id}</td>
                    <td>{poolInfo.upline_id}</td>
                    <td>{poolInfo.down_node}</td>
                    <td>{poolInfo.down_count}</td>
                    <td>{poolInfo.created_at}</td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default Poolinfo;
